// extracted by mini-css-extract-plugin
export default {"alertHolder":"alertHolder-lnusx","alert":"alert-tuHr4","appearance":"appearance-1Mp0i","actions":"actions-h_DP_","text":"text-vIL2W"};